import { notification } from "antd";
import React from "react";

export const SuccessNotification = (
  title,
  message = "",
  onClick = () => {},
  onClose = () => {}
) => {
  notification.success({
    message: title,
    onClick: onClick,
    onClose: onClose,
    description: message,
    duration: 3,
    showProgress: true,
    pauseOnHover: true,
  });
};

export const ErrorNotification = (
  title,
  message = "",
  onClick = () => {},
  onClose = () => {}
) => {
  notification.error({
    message: title,
    onClick: onClick,
    onClose: onClose,
    duration: 3,
    showProgress: true,
    pauseOnHover: true,
    description: message,
  });
};

export const InfoNotification = (
  title,
  message = "",
  onClick = () => {},
  onClose = () => {}
) => {
  notification.info({
    message: title,
    onClose: onClose,
    onClick: onClick,
    duration: 3,
    showProgress: true,
    pauseOnHover: true,
    description: message,
  });
};

export const WarningNotification = (
  title,
  message = "",
  onClick = () => {},
  onClose = () => {}
) => {
  notification.warning({
    message: title,
    onClick: onClick,
    onClose: onClose,
    duration: 3,
    showProgress: true,
    pauseOnHover: true,
    description: message,
  });
};

const NotificationProviderProps = {
  children: React.ReactNode,
};

export const NotificationProvider = ({ children }) => {
  const [_, contextHolder] = notification.useNotification({
    stack: { threshold: 3 },
    placement: "topRight",
    showProgress: true,
    pauseOnHover: true,
  });

  return (
    <>
      {contextHolder}
      {children}
    </>
  );
};
